<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      <template v-if="editMode">Edycja wariantu produktu</template>
      <template v-else>Dodawanie wariantu produktu</template>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="product-variant-form"
        tag="form">
        <div class="form-group">
          <label for="code">
            Kod EAN:
          </label>

          <validation-provider
            rules="required"
            name="code"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              v-model="data.code"/>
            <div v-if="errors.length" class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <div class="form-group">
          <label for="price"> Cena brutto: </label>

          <validation-provider
            rules="required|min_value:1"
            name="price"
            type="number"
            v-slot="{ errors }">
            <d-input-group append="zł">
              <d-input
                class="text-right"
                :state="errors.length ? 'invalid' : null"
                v-model="data.price"/>
            </d-input-group>
            <div v-if="errors.length" class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <template v-for="(variant, index) of productVariants">
          <div
            class="form-group"
            :key="'variant' + index">
            <label for="variantSelection">
              {{ variant.name }}:
            </label>

            <validation-provider
              rules="required"
              :name="'variant-' + index"
              v-slot="{ errors }">
              <input
                type="hidden"
                v-model="validationHelpers['variant-' + index]" />
              <div v-if="errors.length" class="invalid-feedback d-block">
                {{ errors[0] }}
              </div>
            </validation-provider>

            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': variantHasError[index],
                'vs-wrap-text': true
              }">
              <v-select
                :ref="'variant-selection-dropdown-' + index"
                :options="variant.items"
                v-model="selectedVariants[index]"
                :reduce="(variant) => variant.id"
                placeholder="Wybierz wariant"
                :searchable="true"
                label="name">
              </v-select>
            </div>
            <div
              v-if="variantHasError[index]"
              class="invalid-feedback">
              {{ $refs['product-variant-form'].errors['variant-' + index][0] }}
            </div>
          </div>
        </template>

        <d-row class="pt-2 pb-1">
          <d-col
            lg="6"
            md="6"
            sm="12">
            <d-checkbox
              toggle
              toggle-small
              class="mr-0"
              inline
              v-model="data.available_in_package">
              Dostępny w pakiecie:
            </d-checkbox>
          </d-col>
        </d-row>

        <d-row v-if="data.available_in_package">
          <d-col
            lg="6"
            md="6"
            sm="12">
            <div class="form-group">
              <label for="package_price"> Cena pakietu (brutto): </label>
              <validation-provider
                rules="required|min_value:1"
                name="package_price"
                type="number"
                v-slot="{ errors }">
                <d-input-group append="zł">
                  <d-input
                    class="text-right"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.package_price"/>
                </d-input-group>
                <div v-if="errors.length" class="invalid-feedback d-block">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col
            lg="6"
            md="6"
            sm="12">
            <label class="d-block">Liczba sztuk w pakiecie:</label>
            <d-input-group
              append="szt.">
              <d-input
                class="text-right"
                :min="2"
                :disabled="true"
                v-model="data.quantity_in_package"
                type="number" />
            </d-input-group>
          </d-col>
        </d-row>

        <d-row>
          <d-col
            lg="12"
            md="12"
            sm="12">
            <div class="form-group">
              <label for="minimal-stock"> Nie pozwalaj zamawiać gdy w magazynie jest mniej niż: </label>

              <validation-provider
                rules="required|min_value:0"
                type="number"
                name="minimal-stock"
                v-slot="{ errors }">
                <d-input-group
                  append="szt.">
                  <d-input
                    class="text-right"
                    v-model="data.minimal_stock"/>
                  </d-input-group>
                <div v-if="errors.length" class="invalid-feedback d-block">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>

      </validation-observer>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="submitInProgress"
        @click.prevent="validateForm">
        <div
          v-if="submitInProgress"
          class="spinner-border spinner-border-sm"
          role="status">
        </div>
        <template v-if="editMode">Zapisz zmiany</template>
        <template v-else>Dodaj</template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'product-variant-popup',
  computed: {
    variantHasError () {
      let errors = [];

      for (let i = 0; i < this.productVariants.length; i++) {
        errors[i] = this.$refs['product-variant-form'] &&
                    this.$refs['product-variant-form'].errors &&
                    this.$refs['product-variant-form'].errors['variant-' + i] &&
                    this.$refs['product-variant-form'].errors['variant-' + i].length;
      }

      return errors;
    },
    availableInPackage () {
      return this.data.available_in_package;
    }
  },
  data() {
    return {
      data: {
        id: null,
        price: 0,
        code: '',
        variant_items: [],
        available_in_package: false,
        package_price: 0,
        quantity_in_package: 0,
        minimal_stock: 0
      },
      validationHelpers: {},
      allVariants: [],
      selectedVariants: [],
      productVariants: {},
      isHidden: true,
      submitInProgress: false,
      referrerData: null,
      editMode: false,
    };
  },
  watch: {
    selectedVariants: {
      handler () {
        for (let i = 0; i < this.selectedVariants.length; i++) {
          this.validationHelpers['variant-' + i] = this.selectedVariants[i];
        }
      },
      deep: true
    },
    availableInPackage (newValue) {
      if (newValue) {
        this.data.quantity_in_package = 2;
      } else {
        this.data.quantity_in_package = 0;
      }
    }
  },
  mounted() {
    this.$bus.$on('product-variant-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    validateForm() {
      FormUtils.validate(this.$refs['product-variant-form'], this.save);
    },
    prepareFormDataToSend() {
      let formDataToSend = {
        parent_id: this.referrerData.id,
        code: this.data.code,
        price: this.data.price,
        variant_items: this.selectedVariants,
        type: 'CHILD',
        available_in_package: this.data.available_in_package ? 1 : 0,
        minimal_stock: this.data.minimal_stock
      };

      if (this.editMode) {
        formDataToSend.id = this.data.id;
      }

      if (this.data.available_in_package) {
        formDataToSend.quantity_in_package = this.data.quantity_in_package;
        formDataToSend.package_price = this.data.package_price;
      }

      return formDataToSend;
    },
    save() {
      this.submitInProgress = true;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.editMode
        ? '/api/products/update/' + this.data.id
        : '/api/products/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano wariant',
        successText: 'Wybrany wariant został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisanie wariantu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.closePopup();
          this.submitInProgress = false;
          this.$bus.$emit('product-variant-added');
        },
        failAction: () => {
          this.submitInProgress = false;
        }
      });
    },
    openPopup(parentProduct, allVariants = [], selectedVariant = null, isEditMode = false) {
      this.editMode = isEditMode;
      if (this.editMode) {
        this.data.id = selectedVariant.id;
        this.data.price = selectedVariant.price;
        this.data.code = selectedVariant.code;
        this.data.variant_items = selectedVariant.variant_items;
        this.data.available_in_package = !!selectedVariant.available_in_package;
        this.data.package_price = selectedVariant.package_price;
        this.data.quantity_in_package = selectedVariant.quantity_in_package;
        this.data.minimal_stock = selectedVariant.minimal_stock
      } else {
        this.data.id = null;
        this.data.price = 0;
        this.data.code = '';
        this.data.variant_items = [];
        this.data.available_in_package = false;
        this.data.package_price = 0;
        this.data.quantity_in_package = 0;
        this.data.minimal_stock = 0;
      }

      this.selectedVariants = [];
      this.referrerData = parentProduct;
      this.allVariants = allVariants.slice();
      let productVariants = this.referrerData.variants.slice().map(variant => variant.id);
      this.productVariants = allVariants.slice().filter(variant => productVariants.indexOf(variant.id) > -1);

      if (this.editMode) {
        this.selectedVariants = selectedVariant.variant_items.slice().map(variant => variant.id);
      }

      for (let i = 0; i < this.productVariants.length; i++) {
        this.validationHelpers['variant-' + i] = null;
      }

      setTimeout(() => {
        this.isHidden = false;
        if (this.$refs['product-variant-form']) {
          this.$refs['product-variant-form'].reset();
        }
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
    closePopup() {
      this.editMode = false;
      this.submitInProgress = false;
      this.isHidden = true;
    }
  },
  beforeDestroy() {
    this.$bus.$off('product-variant-popup-show', this.openPopup);
  }
};
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
